(function($) {

  /**
   */
  Drupal.behaviors.hero_tout = {
    attach: function(context, settings) {

      // Specific to Style 1
      /*
      var $tout1 = $('.tout--style1'),
        $toutHeader = $('.hero-tout__header', $tout1),
        $toutWrapper = $tout1.parent('.hero-tout-wrapper');

        // Resize images 1) immediately after 200ms, 2) 200ms after every resize
        var lazyStyle1Size = _.throttle(style1Size, 200, {leading: false});
        $(window).resize(lazyStyle1Size).resize();

        function style1Size() {

          var headerHeight = $toutHeader.height(),
            toutHeight = $toutWrapper.height(),
            imgHeight = toutHeight - headerHeight;

          $('.hero-tout__image img', $tout1).css({
            'height': imgHeight,
            'width': 'auto'
          });
        }
        */


  //     var $hero_c = $('.homepage__hero--c');
  //       // window_ratio = parseInt($(window).height(),10) / parseInt($(window).width(),10);

  //     // wait until hero_c images load, get dimensions
  //     $('img', $hero_c).load(function(){
  //       var img_ratio = parseInt($(this).width(), 10) / parseInt($(this).height(), 10);

  //       $(this).removeClass('full-width full-height');

  //       // extend one side of image based on if image is wide/tall
  //       if (img_ratio > 1){
  //         $(this).addClass('full-height');
  //       } else{
  //         $(this).addClass('full-width');
  //       }
  //     });
    }
  };

})(jQuery);
